import { render } from "./StatementsModalView.vue?vue&type=template&id=27ca84ad"
import script from "./StatementsModalView.vue?vue&type=script&lang=js"
export * from "./StatementsModalView.vue?vue&type=script&lang=js"

import exportComponent from "/gui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__